if (!customElements.get('size-and-weight')) {
  customElements.define('size-and-weight', class SizeAndWeight extends HTMLElement {
    constructor() {
      super();

      this.metricValues = this.querySelectorAll("[id$='--metric']");
      this.imperialValues = this.querySelectorAll("[id$='--imperial']");

      this.metricButton = this.querySelector("#metric--button");
      this.imperialButton = this.querySelector("#imperial--button");

    }

    connectedCallback() {
        this.metricButton.addEventListener('click', this.showMetric.bind(this));
        this.imperialButton.addEventListener('click', this.showImperial.bind(this));
    }

    showMetric() {
      this.imperialValues.forEach(imperialValue => {
        imperialValue.classList.add('hidden');
      });
      this.metricValues.forEach(imperialValue => {
        imperialValue.classList.remove('hidden');
      });
      this.metricButton.classList.add('active')
      this.imperialButton.classList.remove('active')
    }

    showImperial() {
        this.imperialValues.forEach(imperialValue => {
            imperialValue.classList.remove('hidden');
        });
        this.metricValues.forEach(imperialValue => {
            imperialValue.classList.add('hidden');
        });
        this.metricButton.classList.remove('active')
        this.imperialButton.classList.add('active')
    }
  }
)}